class Component {
  onTurnTaken() {
    return;
  }
}

export default Component;
